import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  Grid,
  Stack,
  Typography,
} from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import ListAltIcon from '@mui/icons-material/ListAlt';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const COLORES_ICONOS = ['#00a0b9', '#22a36a', '#7c3aed'];

const cardContenedorSx = {
  bgcolor: '#ffffff',
  borderRadius: 3,
  boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  overflow: 'hidden' as const,
};

const enlaces = [
  {
    titulo: 'Listas de precios',
    descripcion:
      'Administrá listas de precios de venta, vigencias y condiciones comerciales.',
    path: '/ventas/listaprecios',
    icon: <ListAltIcon />,
  },
  {
    titulo: 'Importación de Costos Base por código de Proveedor',
    descripcion:
      'Importa costos desde Excel usando el Codigo de Proveedor; Actualiza el CPP del proveedor principal y recalculá el Precio de venta Base.',
    path: '/inventario/importacion-costos-proveedor',
    icon: <UploadFileIcon />,
  },
  {
    titulo: 'Importación de Costos Base por código de artículo',
    descripcion:
      'Importá costos desde Excel usando el Codigo de Articulo; Actualiza el CPP del proveedor principal y recalculá el Precio de venta Base.',
    path: '/inventario/importacion-costos-articulo',
    icon: <ArticleIcon />,
  },
];

const MantenimientoPreciosInventario: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        p: { xs: 2, sm: 3 },
        bgcolor: '#f5f5f5',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
      }}
    >
      <Card
        sx={{
          ...cardContenedorSx,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          minHeight: 0,
        }}
      >
        <CardContent
          sx={{
            p: { xs: 2, sm: 3 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 600,
                color: '#1976d2',
                mb: 1,
              }}
            >
              Mantenimiento de costos y precios
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.95rem', maxWidth: 720 }}>
              Elegí una opción para trabajar listas de venta o la importación masiva de costos desde planillas (por
              proveedor o por código de artículo).
            </Typography>
          </Box>

          <Grid container spacing={2.5} sx={{ flex: 1, alignContent: 'flex-start' }}>
            {enlaces.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} lg={3} key={item.path}>
                <Card
                  sx={{
                    borderRadius: 3,
                    border: '1px solid #e0e0e0',
                    overflow: 'hidden',
                    height: '100%',
                    minHeight: { xs: 180, sm: 195 },
                    transition: 'all 0.3s ease',
                    position: 'relative',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 20px rgba(0,0,0,0.12)',
                      borderColor: '#1976d2',
                    },
                  }}
                >
                  <CardActionArea
                    onClick={() => navigate(item.path)}
                    sx={{
                      p: 0,
                      height: '100%',
                      alignItems: 'stretch',
                      '&:hover': {
                        '& .MuiCardActionArea-focusHighlight': {
                          opacity: 0,
                        },
                      },
                    }}
                  >
                    <CardContent sx={{ p: 2.25 }}>
                      <Stack spacing={1.5}>
                        <Box
                          sx={{
                            width: 48,
                            height: 48,
                            borderRadius: 2,
                            bgcolor: COLORES_ICONOS[index % COLORES_ICONOS.length],
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            '& .MuiSvgIcon-root': {
                              fontSize: 27,
                            },
                          }}
                        >
                          {item.icon}
                        </Box>
                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#1a1a1a', mb: 0.5 }}>
                          {item.titulo}
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.975rem', lineHeight: 1.6 }}>
                          {item.descripcion}
                        </Typography>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            color: '#1976d2',
                            fontWeight: 500,
                            fontSize: '0.85rem',
                          }}
                        >
                          Abrir
                          <Box
                            component="span"
                            sx={{
                              ml: 1,
                              transition: 'transform 0.3s ease',
                              display: 'inline-block',
                              '&:hover': {
                                transform: 'translateX(4px)',
                              },
                            }}
                          >
                            →
                          </Box>
                        </Box>
                      </Stack>
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default MantenimientoPreciosInventario;
